import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const Bullz = () => {
  useEffect(() => {
    // App carousel slider
    const slider = document.getElementById("slider");
    if (!slider) return;

    let currentIndex = 0;
    const slides = slider.children;
    const totalSlides = slides.length;

    const slide = () => {
      if (totalSlides > 0) {
        currentIndex = (currentIndex + 1) % (totalSlides - 2);
        slider.style.transform = `translateX(-${currentIndex * 33.333}%)`;
      }
    };

    const slideInterval = setInterval(slide, 3000);

    return () => {
      clearInterval(slideInterval);
    };
  }, []);

  return (
    <div className="bullz-page portfolio-details-page">
      <section className="banner-section">
        <div className="intro">
          <div className="intro-bg wow fadeIn" data-wow-delay="0.3s">
            <img
              src="/assets/images/background/intro-bg.jpg"
              alt="Light Background"
            />
          </div>
          <div className="container wow fadeIn" data-wow-delay="0.3s">
            <h1>
              <img src="/assets/images/logos/logo-bullz.svg" alt="bullz" />
            </h1>
            <h2>The ULTIMATE source for everything crypto</h2>
            <div className="breadcrumb">
              <span>
                Portfolio / <strong>Bullz</strong>
              </span>
            </div>
          </div>
        </div>
      </section>

      <section className="whatwedo-section">
        <div className="container">
          <div className="row">
            <div className="col col-4">
              <h2>What We Did</h2>
              <ul className="list">
                <li>Product Architecture</li>
                <li>Mobile Development</li>
                <li>Backend Development</li>
                <li>Security</li>
              </ul>
            </div>
            <div className="col col-8">
              <h2>Overview</h2>
              <p>
                BULLZ is an all-in-one app for anyone looking to learn about and stay up-to-date on the world of
                cryptocurrency. Users can access real and authenticated information about DeFi, NFTs, DApps, and
                other key areas of crypto, all from the convenience of their mobile device. BULLZ also allows
                users to create their own videos, share recommendations with friends, and earn rewards through
                authenticated recommendations.
              </p>
              <p>
                With its focus on authenticity and trust, BULLZ is a valuable resource for anyone looking to
                navigate the complex world of cryptocurrency. The app provides users with a platform to learn,
                create, and share knowledge, while ensuring that all recommendations are authenticated through
                the WOM Protocol. Whether you're a crypto novice or an experienced trader, BULLZ is the ultimate
                source for all things crypto.
              </p>
            </div>
          </div>
          <div className="portfolio-carousel">
            <div className="slide-content">
              <img src="/assets/images/background/bullz/main.webp" alt="bullz" />
            </div>
          </div>
        </div>
      </section>

      <section className="challenges-section">
        <div className="container">
          <div className="challenges">
            <div className="col col-6">
              <div className="img-card">
                <img src="/assets/images/background/bullz/mian-1.webp" alt="bullz" />
              </div>
            </div>
            <div className="col col-6">
              <div className="info-card">
                <h3>Challenges</h3>
                <div className="scroll">
                  <p>
                    Developing an app like BULLZ presents unique challenges for developers. Firstly, the
                    constantly evolving nature of the crypto industry requires the app to be designed to
                    adapt to changes and new trends. Secondly, ensuring the authenticity of information and
                    recommendations is crucial in a platform like BULLZ, with robust security measures
                    required to authenticate all recommendations.
                  </p>
                  <p>
                    Creating a seamless user experience that allows users to easily navigate the app and
                    find the information they need is critical for the success of BULLZ. This requires an
                    intuitive user interface design, cutting-edge technologies to optimize the app's
                    performance, and smooth video streaming. Overall, developing an app like BULLZ requires
                    a thoughtful approach to design and implementation, as well as a dedication to keeping
                    up with the latest industry developments and ensuring user trust in the information
                    provided.
                  </p>
                </div>
              </div>
            </div>
            <div className="col col-6 flex-reverse">
              <div className="img-card">
                <img src="/assets/images/background/bullz/main-2.webp" alt="bullz" />
              </div>
            </div>
            <div className="col col-6">
              <div className="info-card">
                <h3>Solutions</h3>
                <div className="scroll">
                  <p>
                    To address the challenges of developing BULLZ, we implemented several key solutions.
                    Firstly, we used agile development methodologies to ensure that the app can adapt to
                    changes and new trends in the crypto industry. We also implemented regular updates to
                    keep the app up-to-date with the latest developments in the industry.
                  </p>
                  <p>
                    We implemented a user-friendly interface design and cutting-edge technologies to
                    optimize the app's performance and ensure seamless video streaming.
                  </p>
                  <p>
                    Overall, our solutions have allowed us to create a platform that provides users with a
                    seamless and trustworthy experience in the complex world of cryptocurrency. We are
                    committed to continuously improving the app, listening to user feedback, and staying at
                    the forefront of industry developments to provide the best possible experience for our
                    users.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="app-section">
        <div className="container">
          <div className="title">
            <h2>Browse on any device</h2>
            <p>
              Experience responsive, pixel-perfect UI designs on any device with our custom software solutions
            </p>
          </div>
          <div className="app-carousel" id="slider">
            <div className="slide-content">
              <img src="/assets/images/background/bullz/s1.webp" alt="bullz-1" />
            </div>
            <div className="slide-content">
              <img src="/assets/images/background/bullz/s2.webp" alt="bullz-2" />
            </div>
            <div className="slide-content">
              <img src="/assets/images/background/bullz/s3.webp" alt="bullz-3" />
            </div>
            <div className="slide-content">
              <img src="/assets/images/background/bullz/s4.webp" alt="bullz-4" />
            </div>
            <div className="slide-content">
              <img src="/assets/images/background/bullz/s5.webp" alt="bullz-5" />
            </div>
            <div className="slide-content">
              <img src="/assets/images/background/bullz/s6.webp" alt="bullz-6" />
            </div>
            <div className="slide-content">
              <img src="/assets/images/background/bullz/s7.webp" alt="bullz-7" />
            </div>
          </div>
          <div className="download-app">
            <h2>Test Drive our Results</h2>
            <p>Experience the impact of our work firsthand</p>
            <div className="app-link">
              <a
                href="https://apps.apple.com/app/bullz/id1579098036?ign-mpt=uo%3D2"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/assets/images/logos/logo-appstore.png"
                  alt="appstore"
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=io.womprotocol.bullz"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/assets/images/logos/logo-playstore.png"
                  alt="playstore"
                />
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="testimonial-section">
        <div className="container">
          <div className="testimonial-carousel">
            <div className="slide-content">
              <div className="slide-info">
                <h3>
                  Slash Star has become my most preferred, reliable and capable Mobile Development company for
                  several years. Accessible at all times, they communicate through various channels.
                </h3>
                <div className="flex">
                  <div className="client flex">
                    <div className="client-img">
                      <img
                        src="/assets/images/reviews/bullz/client.webp"
                        alt="client"
                      />
                    </div>
                    <div className="client-details">
                      <h4>Melanie Mohr</h4>
                      <h5>CEO, WOM Protocol</h5>
                    </div>
                  </div>
                  <div className="logo-img grayscale">
                    <img src="/assets/images/logos/logo-wom.svg" alt="wom" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="portfolio-section projects-section">
        <div className="container">
          <h2>More Projects</h2>
          <div className="portfolio card-deck-js">
            <div className="portfolio-card">
              <Link to="/finutss">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img
                      src="/assets/images/protfolio/finutz.svg"
                      alt="Finutss"
                    />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Finutss</h3>
                      <div>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow" />
                    </div>
                  </div>
                </div>
              </Link>
              <Link to="/bullz">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img src="/assets/images/protfolio/bullz.svg" alt="bullz" />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Bullz</h3>
                      <div>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow" />
                    </div>
                  </div>
                </div>
              </Link>
              <Link to="/telly">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img src="/assets/images/protfolio/telly.svg" alt="Telly" />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Telly</h3>
                      <div>
                        <span>Web</span>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow" />
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Bullz;
